import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";

import PopUpModal from "../PopUpModal/PopUpModal";
import { generateShareLink } from "../../Helpers/ShareHelper";

import styles from "./ShareModal.module.css";

export default function ShareModal() {
    const dispatch = useDispatch();
    const shareData = useSelector((state) => state.visualizer.shareData);
    const specifier = useSelector(s => s.visualizer.specifier);
    const activeFlooringSeriesIds = useSelector(s => s.visualizer.activeFlooringSeriesIds);
    const [shareLink, setShareLink] = useState("Choose a product first");
    const [copied, setCopied] = useState(false); // <-- New

    const handleClose = () => {
        dispatch(uiActions.setShareModalActive(false));
    };

    useEffect(() => {
        let saveData = document.getElementById('chamViz').getSaveData();
        let result = `${window.location.origin}/visualizer/spec/${encodeURIComponent(specifier)}` +
        `/sel/${encodeURIComponent(saveData.sel)}` +
        `?sids=${activeFlooringSeriesIds}`;

        setShareLink(result)
    }, []);


    const handleCopy = () => {
        navigator.clipboard.writeText(shareLink).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
        });
    };

    return (
        <PopUpModal handleClose={handleClose}>
            <div className={styles.contentMain}>
                <h2>Share Your Project</h2>
                <p id="success-message">{copied && "Copied!"}</p>
                <div className={styles.shareInput} >
                    <input
                        type="text"
                        id="project-link"
                        value={shareLink}
                        readOnly
                        style={{ flex: 1 }}
                    />
                    <button onClick={handleCopy}>Copy</button>
                </div>
            </div>
        </PopUpModal>
    );
}
